import { createIconComponent } from '../../factory/create-icon-component';
export const SouthKoreaIcon = createIconComponent(
  'SouthKoreaIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10027_30906)">
      <path d="M22.9999 5H0.999878V20H22.9999V5Z" fill="white" />
      <path
        d="M14.6778 12.4997C14.6778 13.1845 13.4787 14.8964 11.9995 14.8964C10.5204 14.8964 9.32129 13.1845 9.32129 12.4997C9.32129 10.9869 10.5204 9.76062 11.9995 9.76062C13.4787 9.76062 14.6778 10.9869 14.6778 12.4997Z"
        fill="#D80027"
      />
      <path
        d="M14.6778 12.4998C14.6778 14.0125 13.4787 15.2388 11.9995 15.2388C10.5204 15.2388 9.32129 14.0125 9.32129 12.4998"
        fill="#0052B4"
      />
      <path
        d="M15.5503 14.1949L14.8401 14.9212L15.3135 15.4054L16.0237 14.6791L15.5503 14.1949Z"
        fill="black"
      />
      <path
        d="M14.367 15.4049L13.6569 16.1312L14.1303 16.6154L14.8405 15.889L14.367 15.4049Z"
        fill="black"
      />
      <path
        d="M16.9712 15.6466L16.261 16.3729L16.7344 16.8571L17.4446 16.1308L16.9712 15.6466Z"
        fill="black"
      />
      <path
        d="M15.7879 16.8576L15.0778 17.5839L15.5512 18.0681L16.2614 17.3418L15.7879 16.8576Z"
        fill="black"
      />
      <path
        d="M16.2607 14.9207L15.5505 15.647L16.024 16.1312L16.7341 15.4049L16.2607 14.9207Z"
        fill="black"
      />
      <path
        d="M15.0775 16.1312L14.3673 16.8575L14.8407 17.3417L15.5509 16.6154L15.0775 16.1312Z"
        fill="black"
      />
      <path
        d="M14.3672 8.14163L16.261 10.0784L16.7344 9.59424L14.8406 7.65744L14.3672 8.14163Z"
        fill="black"
      />
      <path
        d="M13.6571 8.86805L14.3673 9.59436L14.8407 9.11021L14.1305 8.3839L13.6571 8.86805Z"
        fill="black"
      />
      <path
        d="M14.8404 10.0787L15.5505 10.8051L16.0239 10.3209L15.3138 9.59459L14.8404 10.0787Z"
        fill="black"
      />
      <path
        d="M15.0766 7.41541L15.7867 8.14172L16.2602 7.65754L15.55 6.93123L15.0766 7.41541Z"
        fill="black"
      />
      <path
        d="M16.2609 8.62611L16.9711 9.35242L17.4445 8.86823L16.7343 8.14192L16.2609 8.62611Z"
        fill="black"
      />
      <path
        d="M8.92223 17.5838L7.02844 15.647L6.55501 16.1312L8.4488 18.068L8.92223 17.5838Z"
        fill="black"
      />
      <path
        d="M9.63193 16.8577L8.92175 16.1313L8.44835 16.6155L9.15853 17.3418L9.63193 16.8577Z"
        fill="black"
      />
      <path
        d="M8.4487 15.6471L7.73853 14.9208L7.26509 15.405L7.97527 16.1313L8.4487 15.6471Z"
        fill="black"
      />
      <path
        d="M10.3428 16.1314L8.44897 14.1946L7.97554 14.6788L9.86933 16.6156L10.3428 16.1314Z"
        fill="black"
      />
      <path
        d="M7.02943 9.35178L8.92322 7.41498L8.44979 6.93079L6.556 8.8676L7.02943 9.35178Z"
        fill="black"
      />
      <path
        d="M7.73842 10.0784L9.6322 8.1416L9.15877 7.65742L7.26499 9.59422L7.73842 10.0784Z"
        fill="black"
      />
      <path
        d="M8.44887 10.8048L10.3427 8.86804L9.86925 8.38389L7.97547 10.3207L8.44887 10.8048Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_10027_30906">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
